import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02M5 9v6h4l5 5V4L9 9z"></path>
  </>,
  'VolumeDown',
)
